import React, { ReactNode } from 'react';
import './form.scss';
import { Form } from 'formik';
import classNames from 'classnames';

export interface ZenFormProps {
    type: 'vertical' | 'horizontal';
    className?: string;
    children: ReactNode;
    onSubmit: (e?: React.FormEvent<HTMLFormElement> | undefined) => void;
    onChange?: (e?: React.FormEvent<HTMLFormElement> | undefined) => void;
}

const ZenForm: React.FC<ZenFormProps> = ({ type = 'vertical', className, children, onSubmit, ...props }) => {
    return (
        <Form className={`zen-form zen-form-${type} ${classNames(className)}`} onSubmit={onSubmit} {...props}>
            {children}
        </Form>
    );
};

export default ZenForm;
